import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';
import { dumiProjects } from '../data';

const CategoryProjectsModal = ({ isOpen, onClose, category }) => {
    const navigate = useNavigate();

    const filteredProjects = useMemo(() => {
        return dumiProjects.filter(
            project => project.category.toLowerCase() === category?.toLowerCase()
        );
    }, [category]);

    const handleProjectClick = (projectId) => {
        navigate(`/proyecto/${projectId}`);
    };

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 overflow-y-auto"
            onClick={(e) => {
                if (e.target === e.currentTarget) {
                    onClose();
                }
            }}
        >
            <motion.div
                variants={fadeIn('up', 0.3)}
                initial="hidden"
                whileInView="show"
                className="bg-white rounded-3xl shadow-2xl w-full max-w-7xl my-8"
            >
                {/* Header */}
                <div className="flex items-center justify-between p-6 lg:p-10 border-b border-gray-200">
                    <h1 className="text-mainYellow text-3xl lg:text-4xl font-bold">
                        {category}
                    </h1>
                    <button
                        onClick={onClose}
                        className="text-4xl text-mainBlue hover:text-mainYellow transition-colors duration-300"
                    >
                        ×
                    </button>
                </div>

                {/* Content */}
                <div className="p-6 lg:p-10">
                    {filteredProjects.length > 0 ? (
                        <div>
                            <p className="text-mainBlue text-lg mb-8">
                                Total de proyectos: {filteredProjects.length}
                            </p>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
                                {filteredProjects.map((project) => (
                                    <motion.div
                                        key={project.id}
                                        variants={fadeIn('up', 0.2)}
                                        initial="hidden"
                                        whileInView="show"
                                        onClick={() => handleProjectClick(project.id)}
                                        className="group relative overflow-hidden rounded-lg cursor-pointer"
                                    >
                                        <div className="aspect-video overflow-hidden rounded-lg bg-gray-200">
                                            {project.images && project.images.length > 0 ? (
                                                <>
                                                    <img
                                                        src={project.images[0].url}
                                                        alt={project.name}
                                                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                                                    />
                                                    <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition-colors duration-300" />
                                                </>
                                            ) : (
                                                <div className="w-full h-full flex items-center justify-center text-gray-400">
                                                    <span>Sin imagen</span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black to-transparent text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            <p className="text-sm font-semibold truncate">{project.name}</p>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="flex items-center justify-center py-16">
                            <p className="text-mainBlue text-xl">No hay proyectos en esta categoría</p>
                        </div>
                    )}
                </div>
            </motion.div>
        </div>
    );
};

export default CategoryProjectsModal;
